import React from "react";
import { Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const Markup = ({ currentActivity, markupAnswers }) => {
  // Determine if the answer is correct
  const isCorrect = Object.entries(currentActivity.Options).every(
    ([optionIndex, optionsArray]) => {
      const wordIndex = parseInt(optionIndex, 10) - 1;
      const selectedEntries = markupAnswers[wordIndex] || [];

      if (!Array.isArray(selectedEntries) || selectedEntries.length === 0) {
        return false;
      }

      const userSelectedTypes = selectedEntries.map((entry) => entry.type);
      const correctTypes = optionsArray.map((opt) => opt.Type);

      return (
        userSelectedTypes.length === correctTypes.length &&
        JSON.stringify(userSelectedTypes.slice().sort()) ===
          JSON.stringify(correctTypes.slice().sort())
      );
    }
  );

  return (
    <>
      {isCorrect ? (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "green",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Correct Answer!
          </Typography>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CancelIcon sx={{ fontSize: 40, color: "red" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "red",
              textAlign: "center",
              marginTop: 1,
            }}
          >
            Incorrect Answer!
          </Typography>

          {/* Show rationale for incorrect answers only */}
          {Object.entries(currentActivity.Options).map(
            ([optionIndex, optionsArray]) =>
              optionsArray.map((option, i) => {
                const rationale = option.Rationale;
                const text = rationale?.Text?.trim();
                const contentId = rationale?.ContentId;

                return (
                  <Box
                    key={`rationale-${optionIndex}-${i}`}
                    sx={{
                      marginTop: 1,
                      fontSize: "0.75rem",
                      color: "text.secondary",
                      padding: "8px",
                      border: "1px solid #eee",
                      borderRadius: "4px",
                    }}
                  >
                    {text ? (
                      <Typography>
                        {`Rationale for Option ${optionIndex}: ${text}`}
                      </Typography>
                    ) : contentId ? (
                      <Box>
                        {/* Replace with your actual lesson rendering logic */}
                        <Typography fontWeight="bold">{`Rationale for Option ${optionIndex}:`}</Typography>
                        <Box sx={{ mt: 1 }}>
                          Showing lesson for content ID: {contentId}
                          {/* Example: <LessonRenderer contentId={contentId} /> */}
                        </Box>
                      </Box>
                    ) : (
                      <Typography fontStyle="italic">
                        {`Rationale for Option ${optionIndex} not available.`}
                      </Typography>
                    )}
                  </Box>
                );
              })
          )}
        </>
      )}
    </>
  );
};

export default Markup;
